import { Component, OnInit, Input } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { SmartModalService } from 'src/modules/base/services/smart-modal.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';
import { DialogRef } from 'src/modules/base/components/dialog/dialog-ref';

@Component({
    selector: 'app-image-upload-popup',
    templateUrl: './image-upload-popup.component.html',
    styleUrls: ['./image-upload-popup.component.scss'],
    standalone: false
})

export class ImageUploadPopupComponent implements OnInit {
  @Input() dataForCard: Array<any>;
  @Input() documentId: any;
  data_: any;
  question: any;
  data: any;
  public _currentData: any = {};
  config: any;
  resourceDef: any;

  constructor(
    private baseService: BaseService,
    private smartModalService: SmartModalService,
    private alerts: AlertsService,
    private router: Router,
    private dialogConfig: DialogConfig,
    private dialogRef: DialogRef
  ) { }

  ngOnInit() {
    this.config = {
      "submitButton" : true,
      "cancelButton" : false,
      "filterForm" : false,
      "clearOnSave": true,
      "delegateSave": true,
      "cancelRoute": ''
    }
    this.data_ = this.dialogConfig;
   
    this.baseService.getResourceDef('image_upload', (response) => {
      if (response) {
        this.resourceDef = response
        //this.getFormField(response);
      }
    });
  }
  // getFormField(resouceDef) {
  //   this.baseService.getReferredField(resouceDef.form, (response) => {
  //     //console.log("Resource Data ", response);
  //     this._currentData.currentFormFields = {};
  //     this._currentData.currentFormFields.blocks = response;
  //     //console.log("Resource Fields ", this._currentData.currentFormFields);
  //   });
  // }
  closePopup() {
    this.dialogRef.close();
  }
  onSaveFinished(data_) {
    data_.result['id'] = this['data_'].id;
    if(this['data_'].resource=='practitioner_facility_details_doctor'){
      this.actionAPI(data_,"UPLOAD_PROFILE_PHOTO", "facility-management","practitioner");
    }
    else if(this['data_'].resource=='patient' || this['data_'].resource=='pre_registration' || this['data_'].resource=='temp_mr'){
      this.actionAPI(data_,"UPLOAD_PROFILE_PHOTO", "patient-registration","patient");
    }
    else if(this['data_'].resource=='practitioner_facility_details_other'){
      this.actionAPI(data_,"UPLOAD_PROFILE_PHOTO", "facility-management","practitioner");
    }
    this. closePopup();
  }
  actionAPI(data_, action, application, resource){
    this.baseService.action(data_.result, action, application, resource).subscribe(
      (data: any) => {
        if (data.errCode == -1) {
          this.alerts.error(data.message);
        } else {
          this.alerts.success("Uploaded Successfully");
          this.smartModalService.sendResult(data_.result.profile_id);
        }
      }, error => {
        console.log(error);
      }
    )
  }
}
